import { render } from "./NewPasswordWidget.vue?vue&type=template&id=fe6a6e7c&ts=true"
import script from "./NewPasswordWidget.ts?vue&type=script&lang=ts&external"
export * from "./NewPasswordWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__